import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../../shared/shared.module';

import { IndexComponent } from './index/index.component';
import { DealCollectionComponent } from './deal-collection/deal-collection.component';
import { NewCollectionComponent } from './new-collection/new-collection.component';
import { CarouselModule } from 'ngx-owl-carousel-o';

@NgModule({
	declarations: [
		IndexComponent,		
		DealCollectionComponent,
		NewCollectionComponent,		
	],

	imports: [
		CommonModule,
		RouterModule,
		NgbModule,		
		CarouselModule,
		SharedModule
	]
})

export class HomeModule { }
